/** PURE_IMPORTS_START .._.._Observable,.._.._operator_publish PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { publish } from '../../operator/publish';
Observable.prototype.publish = publish;
//# sourceMappingURL=publish.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/publish.js
// module id = ./node_modules/rxjs/_esm5/add/operator/publish.js
// module chunks = vendor